import { render, staticRenderFns } from "./GlobalLayout.vue?vue&type=template&id=2bf3d487&"
import script from "./GlobalLayout.vue?vue&type=script&lang=js&"
export * from "./GlobalLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports